import { useMemo } from "react";
import { useCsCfgObject } from "./useCsCfgObject";
/**
 * Find a specific attribute by id
 * - requires {@linkcode ConfigurationController}
 *
 * @category Hook
 * @category CsCfgObject
 * @export
 * @template TAttribute
 * @param {string} attributeId - attribute.ident
 * @returns {TAttribute} The attribute or null
 *
 */
export function useCsAttributeById(attributeId) {
    const { attributes } = useCsCfgObject();
    const attribute = attributes === null || attributes === void 0 ? void 0 : attributes.find((a) => a.id === attributeId);
    return useMemo(() => {
        return attribute;
    }, [attribute]);
}
//# sourceMappingURL=useCsAttributeById.js.map